export default "skymp5-front/e197a558b8027cfddbdfca28a6e01ba8.mp3";